module.exports = __webpack_public_path__ + "static/e-commerce.8d7c43fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/e-commerce.jpg
// module id = 844
// module chunks = 267660657819475